import TotalSales from './TotalSales';

export default (props) => {
  return <TotalSales {...props} />;
};
